import FollowUpsAPI from '../../api/followUps';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  allRecords: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingAll: false,
  },
};

const getters = {
  getFollowUps: $state => conversationId => {
    return $state.records.filter(msg => msg.conversation_id === conversationId);
  },
  getAllFollowUps: $state => $state.allRecords,
  getUIFlags: $state => $state.uiFlags,
  getFollowUp: $state => id => {
    return $state.records.find(msg => msg.id === id);
  },
};

const actions = {
  fetchAll: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetchingAll: true });
    try {
      const response = await FollowUpsAPI.getAll();
      commit('SET_ALL_FOLLOW_UPS', response.data.payload);
      commit('SET_UI_FLAG', { isFetchingAll: false });
    } catch (error) {
      commit('SET_UI_FLAG', { isFetchingAll: false });
      throwErrorMessage(error);
    }
  },

  fetch: async ({ commit }, conversationId) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await FollowUpsAPI.get({ conversationId });
      commit('SET_FOLLOW_UPS', response.data.payload);
      commit('SET_UI_FLAG', { isFetching: false });
    } catch (error) {
      commit('SET_UI_FLAG', { isFetching: false });
      throwErrorMessage(error);
    }
  },

  create: async ({ commit }, { conversationId, messageData }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await FollowUpsAPI.create(conversationId, messageData);
      commit('ADD_FOLLOW_UP', response.data);
      commit('SET_UI_FLAG', { isCreating: false });
      return response.data;
    } catch (error) {
      commit('SET_UI_FLAG', { isCreating: false });
      throwErrorMessage(error);
      throw error;
    }
  },

  update: async ({ commit }, { conversationId, id, messageData }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await FollowUpsAPI.update(
        conversationId,
        id,
        messageData
      );
      commit('UPDATE_FOLLOW_UP', response.data);
      commit('SET_UI_FLAG', { isUpdating: false });
      return response.data;
    } catch (error) {
      commit('SET_UI_FLAG', { isUpdating: false });
      throwErrorMessage(error);
      throw error;
    }
  },

  delete: async ({ commit }, { conversationId, id }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await FollowUpsAPI.delete(conversationId, id);
      commit('DELETE_FOLLOW_UP', id);
      commit('SET_UI_FLAG', { isDeleting: false });
    } catch (error) {
      commit('SET_UI_FLAG', { isDeleting: false });
      throwErrorMessage(error);
      throw error;
    }
  },

  cancel: async ({ commit }, { conversationId, id }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await FollowUpsAPI.cancel(conversationId, id);
      commit('UPDATE_FOLLOW_UP', response.data);
      commit('SET_UI_FLAG', { isUpdating: false });
      return response.data;
    } catch (error) {
      commit('SET_UI_FLAG', { isUpdating: false });
      throwErrorMessage(error);
      throw error;
    }
  },

  retrySend: async ({ commit }, { conversationId, id }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await FollowUpsAPI.retrySend(conversationId, id);
      commit('UPDATE_FOLLOW_UP', response.data);
      commit('SET_UI_FLAG', { isUpdating: false });
      return response.data;
    } catch (error) {
      commit('SET_UI_FLAG', { isUpdating: false });
      throwErrorMessage(error);
      throw error;
    }
  },

  fetchCount: async (context, conversationId) => {
    try {
      const response = await FollowUpsAPI.getCount(conversationId);
      return response.data.count || 0;
    } catch (error) {
      throwErrorMessage(error);
      return 0;
    }
  },
};

const mutations = {
  SET_ALL_FOLLOW_UPS($state, messages) {
    $state.allRecords = messages;
  },

  SET_FOLLOW_UPS($state, messages) {
    $state.records = messages;
  },

  ADD_FOLLOW_UP($state, message) {
    $state.records.push(message);
    // Also add to allRecords if it exists
    const existsInAll = $state.allRecords.find(msg => msg.id === message.id);
    if (!existsInAll) {
      $state.allRecords.push(message);
    }
  },

  UPDATE_FOLLOW_UP($state, updatedMessage) {
    const index = $state.records.findIndex(msg => msg.id === updatedMessage.id);
    if (index !== -1) {
      $state.records.splice(index, 1, updatedMessage);
    }
    // Also update in allRecords
    const allIndex = $state.allRecords.findIndex(
      msg => msg.id === updatedMessage.id
    );
    if (allIndex !== -1) {
      $state.allRecords.splice(allIndex, 1, updatedMessage);
    }
  },

  DELETE_FOLLOW_UP($state, id) {
    $state.records = $state.records.filter(msg => msg.id !== id);
    $state.allRecords = $state.allRecords.filter(msg => msg.id !== id);
  },

  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
